import Vue from 'vue'
import decode from 'jwt-decode'

import {emitter, events} from '../../../../emitter'
import {AUTH_SESSION_COOKIE_TTL, RENEW_TOKEN_BEFORE} from '../../../plugins/auth'
import {LOGIN, LOGOUT, SET_PERMISSIONS} from './mutation-types'

export default {
  observe ({dispatch}) {
    emitter.$on(events.SESSION_CHECK, () => {
      dispatch('check')
    })
  },

  async check ({rootState, commit, dispatch}) {
    // check session
    const session = Vue.$auth.getUserSession()

    if (!session && rootState.account.id) {
      dispatch('logout')
    }

    if (!session.idToken) {
      return
    }

    // check token expiration
    // Check if we need to renew token
    const now = new Date().getTime()

    if (now > session.expiresAt - RENEW_TOKEN_BEFORE) {
      await dispatch('renew')
    } else {
      commit(LOGIN, session)
      await dispatch('account/createAccount', decode(session.idToken), {
        root: true
      })
    }
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${session.idToken}`
    commit(SET_PERMISSIONS, [
      rootState.account.role,
    ])
  },

  async login ({rootState, commit, dispatch}) {
    try {
      const response = await Vue.$auth.authenticate()
      const token = decode(response.idToken)
      const exp = token.exp * 1000
      const data = {
        idToken: response.idToken,
        expiresAt: exp,
        userInfo: token
      }
      Vue.$auth.createSession(response.idToken, new Date(exp))
      commit(LOGIN, data)
      await dispatch('account/createAccount', token, {root: true})

      Vue.$http.defaults.headers.common.Authorization = `Bearer ${response.idToken}`
      commit(SET_PERMISSIONS, [
        rootState.account.role
      ])

      console.log('[LOGIN SUCCESS]')
      Vue.router.replace({
        name: 'dashboard.index'
      })
    } catch (e) {
      console.error('[LOGIN ERROR]', e)

      Vue.router.replace({
        name: '404'
      })
    }
  },

  async renew ({rootState, commit, dispatch}) {
    try {
      const response = await Vue.$auth.renew()
      const newExpiresAt = new Date(
        new Date().getTime() + AUTH_SESSION_COOKIE_TTL
      )
      Vue.$auth.createSession(response.idToken, newExpiresAt)

      commit(LOGIN, {idToken: response.idToken, expiresAt: newExpiresAt})

      if (!rootState.account.email) {
        await dispatch('account/createAccount', decode(response.idToken), {
          root: true
        })
      }
      Vue.$http.defaults.headers.common.Authorization = `Bearer ${response.idToken}`
      commit(SET_PERMISSIONS, [
        rootState.account.role,
        ...rootState.account.permissions
      ])
    } catch (e) {
      console.error('[RENEW ERROR]', e)

      dispatch('logout')
    }
  },

  logout ({commit, dispatch}) {
    commit(LOGOUT)
    dispatch('account/logout', null, {root: true})
    Vue.$auth.clearSession()
    Vue.$http.defaults.headers.common.Authorization = ''
    Vue.$auth.logout()
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/actions.js